import EfVideo from '@elem/ui/ef-video';
import css from './index.module.scss';
import EfSpec from '@elem/ui/ef-spec';
import { useLang } from '@/i18n';
import { useEffect, useState } from 'react';
import { tab1Icon, tab2Icon, tab3Icon } from '@elem/compPage/Oasis/comps/TabImg/Icon';

interface ItemProps {
    sources: [string, string];
    posters: [string, string];
    tab: string;
    icon: JSX.Element;
    desc: any;
}
export default function B() {
    const { t } = useLang('delta_pro_ultra.launch.detail.OASIS');
    const [enter, setEnter] = useState(false);
    const [active, setActive] = useState(0);
    const items: ItemProps[] = [
        {
            sources: [
                'https://websiteoss.ecoflow.com/upload/video/1747901433372/%E7%99%BD%E5%A4%A9-%E5%85%89%E7%BA%BFmp4_1.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1747901433372/%E7%99%BD%E5%A4%A9-%E5%85%89%E7%BA%BFmp4_1.mp4',
            ],
            posters: [
                'https://websiteoss.ecoflow.com/upload/image/1747901433502/image%205154391%20(1).png',
                'https://websiteoss.ecoflow.com/upload/image/1747901433502/image%205154391%20(1).png',
            ],
            tab: t('E_item1_title'),
            icon: tab1Icon,
            desc: 'E_item1_desc',
        },
        {
            sources: [
                'https://websiteoss.ecoflow.com/upload/video/1735612530504/TabImg2.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1735612540314/TabImg2-h5.mp4',
            ],
            posters: [
                'https://websiteoss.ecoflow.com/upload/image/1735636706348/TabImg2-poster.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1735637623786/TabImg2-poster-h5.jpg',
            ],
            tab: t('E_item2_title'),
            icon: tab2Icon,
            desc: 'E_item2_desc',
        },
        {
            sources: [
                'https://websiteoss.ecoflow.com/upload/video/1735612530318/TabImg3.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1735612540674/TabImg3-h5.mp4',
            ],
            posters: [
                'https://websiteoss.ecoflow.com/upload/image/1735636706555/TabImg3-poster.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1735637623971/TabImg3-poster-h5.jpg',
            ],
            tab: t('E_item3_title'),
            icon: tab3Icon,
            desc: 'E_item3_desc',
        },
    ];

    const handleChangeTab = (e: MouseEvent, k: number) => {
        const target = e.target as HTMLElement;
        const line = document.querySelector('.OASIS-E .line') as HTMLElement;

        // 对准下面的条
        const { left, width } = target.getBoundingClientRect();
        const { left: parentLeft = left } = target.parentElement?.getBoundingClientRect() ?? {};
        const scrollX = (target.parentElement as HTMLElement).scrollLeft ?? 0;
        line.style.transform = `translateX(${left - parentLeft + scrollX}px)`;
        line.style.width = `${width}px`;

        // h5 情况下切换 tab 需要显示出来
        if (window.innerWidth <= 1024) {
            target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }

        setActive(k);
        const targetVideo = document.querySelector(`.OASIS-E .video${k + 1} video`) as HTMLVideoElement;
        if (targetVideo) {
            targetVideo.currentTime = 0;
            targetVideo.play();
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const scene = AniContainer.create({
                triggerElement: '.dpu-detail-I',
                triggerHook: 1,
                offset: '100%',
                onEnter: () => setEnter(true),
            });

            return () => {
                scene.destroy();
            };
        }
    }, []);

    return (
        <>
            <section id="OASIS-E" className={`OASIS-E ${css['OASIS-E']}`}>
                <EfSpec />
                <div className="info">
                    <h2 className="title">{t('E_title')}</h2>
                    <p className="text">{t('E_desc')}</p>
                </div>
                <ul className="videos">
                    {items?.map((item: ItemProps, k: number) => (
                        <li key={k} className={`video video${k + 1} ${k === active ? 'active' : ''}`}>
                            {enter && (
                                <EfVideo
                                    className="video1"
                                    pc={item.sources[0]}
                                    h5={item.sources[0]}
                                    poster={item.posters[0]}
                                    posterH5={item.posters[1]}
                                    loop={true}
                                    autoPlay={true}
                                />
                            )}
                        </li>
                    ))}
                </ul>
                <ul className="tabs">
                    {items?.map((item: ItemProps, k: number) => (
                        <li className={`tab ${active === k ? 'active' : ''}`} onClick={(e: MouseEvent) => handleChangeTab(e, k)}>
                            {item.icon}
                            <span className="tab-text">{item.tab}</span>
                        </li>
                    ))}
                    <p className="line"></p>
                </ul>
                <p className="desc">
                    {t.rich(items[active].desc, {
                        w: (child: string) => <span className="white-text">{child}</span>,
                    })}
                </p>
            </section>
        </>
    );
}
